export default __webpack_public_path__ + "home3.jpg";